<template>
  <v-menu
    v-model="menu"
    :left="$vuetify.breakpoint.mdAndUp"
    :close-on-content-click="false"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        v-on="on"
      >
        <v-badge
          :value="hasAlerts"
          dot
          overlap
          color="error"
          class="alert-badge"
        >
          <v-icon color="accent">
            notifications
          </v-icon>
        </v-badge>
      </v-btn>
    </template>


    <v-card
      width="400px"
    >
      <v-card-title class="px-1 py-2">
        <v-toolbar
          flat
          dense
          height="30px"
        >
          <v-toolbar-title class="subtitle-1">
            Alerts
          </v-toolbar-title>
          <v-spacer />

          </v-btn>

          <v-btn
            v-if="items.length > 0"
            text
            small
            rounded
            color="primary"
            class="caption"
            @click="markAllAsRead"
          >
            Mark all as read
          </v-btn>

          <v-divider
            class="mx-2"
            vertical
          />

          <v-btn
            small
            icon
            @click="menu = false; $router.push({ name: 'alert-settings' })"
          >
            <v-icon small>
              settings
            </v-icon>
          </v-btn>
        </v-toolbar>
      </v-card-title>

      <v-divider />

      <v-card-text
        class="pa-0 "
      >
        <v-row
          v-if="items.length > 0"
          class="alert-content"
        >
          <v-col cols="12">
            <v-list
              three-line
              subheader
              class="py-0"
            >
              <template v-for="(item, index) in items">
                <v-list-item>
                  <v-list-item-avatar>
                    <v-icon right>
                      mail_outline
                    </v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                    <v-list-item-subtitle>{{ item.body }}</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <!--                {{ item.isRead }}-->
                    <v-btn
                      icon
                      small
                      @click="markAsRead(item.id)"
                    >
                      <v-icon color="grey">
                        done
                      </v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>

                <v-divider v-if="index + 1 !== items.length" />
              </template>
            </v-list>
          </v-col>
        </v-row>

        <v-row
          v-if="items.length === 0"
          class="alert-content"
          justify="center"
          align="center"
        >
          <span>You have no unread alerts</span>
        </v-row>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-row justify="center">
          <v-btn
            text
            rounded
            small
            color="primary"
            @click="menu = false; $router.push({ name: 'alerts' })"
          >
            View all
          </v-btn>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>
<style>
  .alert-badge .v-badge__badge {
    min-width: 13px;
    height: 13px;
    border-radius: 13px;
    top: -3px !important;
    right: -3px !important;
  }

  .alert-content {
    height: 330px;
    overflow-y: auto;
  }
</style>
<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  data() {
    return {
      menu: false
    }
  },
  computed: {
    ...mapGetters([ 'getUnreadAlerts' ]),
    items() {
      return this.getUnreadAlerts
    },
    hasAlerts() {
      return this.items.length > 0
    }
  },
  methods: {
    ...mapActions([ 'markAsRead', 'markAllAsRead' ])
  }
}
</script>
